export default __webpack_public_path__ + "static/media/funfinder-home.63b587cf.png";